import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import config from '../../config';
import { useGlobalContext } from '../../GlobalContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { Add } from '../../service/PageService';

export default function PageNew() {
  const {
    isLoading,
    setIsLoading,
    isAppError,
    setAppError,
    appErrorMessage,
    setAppErrorMessage,
    appErrorTitle,
    setAppErrorTitle,
    appErrorMode,
    setAppErrorMode,
    appUser
  } = useGlobalContext();

  const [name, setName] = useState('');
  const [description, setDescription] = useState('');

  
  const savePage = async (event) => {
    event.preventDefault();
    
    if (name.length < 3) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Name must be at least 3 characters");
      setAppErrorMode("error");
      return;
    }

    setIsLoading(true);

    try {
      const response = await Add(name, description);
      console.log(response);
      if (response.status === 200) {
        setAppError(true);
        setAppErrorTitle("Action Response");
        setAppErrorMessage(response.message || "Page Successfully Added");
        setAppErrorMode("success");
        window.location.href = "/page/list";
      }
      else {
        setAppError(true);
        setAppErrorTitle("Error");
        setAppErrorMessage(response.message || "Failed to add page. Please try again.");
        setAppErrorMode("error");
      }
    } catch (error) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Failed to add page. Please try again.");
      setAppErrorMode("error");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>Page Manage | {config.appName}</title>
      </Helmet>
      <div className='container'>
        <div className='page'>
          <div className='page-heading'>
            <h1>Add Page</h1>
            <span>
              <Link to="/"> Dashboard </Link> / <Link to="/page/list"> Page List </Link> / Page Manage
            </span>
          </div>
          <div className='page-content'>
            <div className="portal">
              <div className='portal-body'>
                <div className='form'>
                  <form onSubmit={savePage} encType='multipart/form-data'>
                    <div className='row'>
                      <div className='col-lg-12 col-md-6 col-sm-6 col-12'>
                        <div className="mb-3">
                          <label className="form-label">Name</label>
                          <input
                            className='form-control'
                            type='text'
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                          />
                        </div>
                      </div> 
                       <div className='col-lg-12 col-md-12 col-sm-6 col-12'>
                        <div className="mb-3">
                          <label className="form-label">Description</label>
                          <textarea
                            className='form-control'
                            rows={8}
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                          ></textarea>
                        </div>
                      </div>                   
                      <div className='clearfix'></div>
                      <div className='col-12 text-end'>
                        <div className="mb-3">
                          <button type='reset' className='btn btn-danger btn-md'>
                            <i className="ri-reset-right-line"></i> Reset
                          </button>
                          &nbsp;&nbsp;
                          <button type='submit' className='btn btn-success btn-md'>
                            <i className="ri-check-fill"></i> Add Page
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
